import { useEffect, useState } from 'react';
import { getGarageGaryAuthLink } from '../../../GarageEditPage/actions';
import { message } from 'antd';

export const useGarageGaryAuthLink = (garageId) => {
    const [autoLoginLink, setAutoLoginLink] = useState(null);
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      setAutoLoginLink(null);
      
      if (!garageId) return undefined;
  
      let isMounted = true;
  
      async function loadGaryLink() {
        setLoading(true);
        try {
          const link = await getGarageGaryAuthLink(garageId);
          if (isMounted) setAutoLoginLink(link);
        }catch(error) {
          if (isMounted) {
            setAutoLoginLink(null);
            message.error(
              error?.response?.data?.message ||
                error?.message ||
                'Could not load Gary login link',
            );
          }
        }
         finally {
          if (isMounted) setLoading(false);
        }
      }
  
      loadGaryLink();
  
      return () => {
        isMounted = false;
      };
    }, [garageId]);
  
    return { autoLoginLink, loading };
  };